import { Photo } from 'components/page/ForeignProfile/common.types'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import {
  filteredMainPhotos,
  filteredPortraitNotMainPhotos,
  filteredRestPhotos,
} from 'components/page/ForeignProfile/Photos/function/filterPhotos'

/**
 * @param data
 * Фотография для профиля в обычной версии
 */
export const usePhotos = (
  foreignProfile: GQLForeignRootQuery['user']
): {
  mainPhoto: Photo | null
  secondaryPhotos: Photo[]
  restPhotos: Photo[]
} => {
  if (!foreignProfile) {
    return {
      mainPhoto: null,
      secondaryPhotos: [] as Photo[],
      restPhotos: [] as Photo[],
    }
  }

  const photos = foreignProfile.photos.photos.nodes

  /**
   * TODO: переделать, неправильно считается _secondaryPhotos в кейсах. Ибо _secondaryPhotos может быть 0
   */
  if (photos.length > 0) {
    const _mainPhoto = filteredMainPhotos(photos)
    const _secondaryPhotos = filteredPortraitNotMainPhotos(photos)
    const _restPhotos = filteredRestPhotos(photos)

    if (
      _mainPhoto.length === 0 &&
      _secondaryPhotos.length === 0 &&
      _restPhotos.length > 0
    ) {
      return {
        mainPhoto: null,
        secondaryPhotos: [],
        restPhotos: _restPhotos,
      }
    }

    if (_mainPhoto.length === 0) {
      const [first, ...restSecondaryPhoto] = _secondaryPhotos

      if (restSecondaryPhoto.length > 3) {
        return {
          mainPhoto: first,
          secondaryPhotos: restSecondaryPhoto.slice(0, 3),
          restPhotos: [...restSecondaryPhoto.slice(3), ..._restPhotos],
        }
      } else {
        return {
          mainPhoto: first,
          secondaryPhotos: restSecondaryPhoto,
          restPhotos: _restPhotos,
        }
      }
    } else {
      if (_secondaryPhotos.length > 3) {
        return {
          mainPhoto: _mainPhoto[0],
          secondaryPhotos: _secondaryPhotos.slice(0, 3),
          restPhotos: [..._secondaryPhotos.slice(3), ..._restPhotos],
        }
      } else {
        return {
          mainPhoto: _mainPhoto[0],
          secondaryPhotos: _secondaryPhotos,
          restPhotos: _restPhotos,
        }
      }
    }
  }

  return {
    mainPhoto: null,
    secondaryPhotos: [] as Photo[],
    restPhotos: [] as Photo[],
  }
}
